<div class="card bcx-card h-100">
  <div class="card-body">
    <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
      <div>
        <p class="text-uppercase text-secondary text-xxs fw-bold mb-1">Risk Context</p>
        <h5 class="card-title fw-bold mb-0">Security, Demographics &amp; Competition</h5>
      </div>
      <span class="badge rounded-pill bg-warning-subtle text-warning-emphasis">
        {{ crimeStats.crimeIndex || 'Unknown' }} risk
      </span>
    </div>

    <div class="row row-cols-2 row-cols-md-4 g-2 mb-3">
      <div class="col">
        <div class="border rounded-3 p-2 h-100">
          <span class="d-block text-uppercase text-secondary text-xxs fw-bold">Precinct</span>
          <strong class="text-xs">{{ crimeStats.precinct || 'Local' }}</strong>
        </div>
      </div>
      <div v-if="crimeStats.periodIncrease" class="col">
        <div class="border rounded-3 p-2 h-100">
          <span class="d-block text-uppercase text-secondary text-xxs fw-bold">Trend</span>
          <strong class="text-xs" :class="crimeStats.periodIncrease.includes('increase') ? 'text-danger' : 'text-success'">
            {{ crimeStats.periodIncrease }}
          </strong>
        </div>
      </div>
      <div v-if="crimeStats.stationContact" class="col">
        <div class="border rounded-3 p-2 h-100">
          <span class="d-block text-uppercase text-secondary text-xxs fw-bold">Police Contact</span>
          <strong class="text-xs">{{ crimeStats.stationContact }}</strong>
        </div>
      </div>
      <div v-if="crimeStats.lastUpdated" class="col">
        <div class="border rounded-3 p-2 h-100">
          <span class="d-block text-uppercase text-secondary text-xxs fw-bold">Updated</span>
          <strong class="text-xs">{{ crimeStats.lastUpdated }}</strong>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between text-secondary text-xs fw-semibold mb-2">
      <span>{{ crimeStats.precinct || 'Local' }} Crime Statistics</span>
      <span v-if="crimeStats.incidentSummary && crimeStats.incidentSummary.length > 0">
        {{ crimeStats.incidentSummary.reduce((sum, crime) => sum + crime.count, 0) }} cases
      </span>
    </div>

    <ul class="list-group list-group-flush" style="max-height: 12.25rem; overflow-y: auto;">
      <li
        v-for="incident in dynamicIncidents"
        :key="incident.id"
        class="list-group-item d-flex align-items-center justify-content-between gap-3 border-start border-4 px-2"
        :class="{
          'border-danger': incident.severity === 'critical',
          'border-warning': incident.severity === 'high',
          'border-info': incident.severity === 'info'
        }"
      >
        <div class="min-w-0">
          <p class="mb-1 fw-semibold text-xs">{{ incident.title }}</p>
          <p class="mb-0 text-secondary text-xs">{{ incident.timestamp }}</p>
        </div>
        <div class="d-flex flex-column align-items-end gap-1 flex-shrink-0">
          <span
            class="badge rounded-pill"
            :class="{
              'bg-success-subtle text-success-emphasis': incident.status === 'Analyzed',
              'bg-warning-subtle text-warning-emphasis': incident.status === 'Pending',
              'bg-info-subtle text-info-emphasis': incident.status === 'No Data'
            }"
          >
            {{ incident.status }}
          </span>
          <span
            v-if="incident.trend"
            class="badge rounded-pill bg-light text-secondary border"
            :class="{
              'text-success': incident.trend.startsWith('-'),
              'text-danger': incident.trend.startsWith('+')
            }"
          >
            {{ incident.trend }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</div>
